import React, { useState } from "react"

import Layout from "src/components/core/templates/layout"
import Hero from "src/components/core/templates/hero/hero"

import Seo from "src/components/seo"
import { container } from "src/pages/services/booking/booking.module.css"

import InfoDelivery from "src/components/partials/booking/infoDelivery"
import InfoProducts from "src/components/partials/booking/infoProducts"
import InfoPersonal from "src/components/partials/booking/infoPersonal"
import Snackbar from "src/components/core/molecules/snackbar"

const Booking = () => {
  const [snackbarVisible, setSnackbarVisible] = useState(false)
  const pageConfig = {
    title: "Review your booking",
    description:
      "We know all bookings have their unique requirements- don’t worry. Please fill out what you can to get the ball rolling and we will be in touch. Any urgent queries? Drop us an email.",
    variant: "city",
  }

  return (
    <Layout>
      <Seo title="Booking Review" />
      <Hero pageConfig={pageConfig} />
      <div className={container}>
        <InfoDelivery />
        <InfoProducts />
        <InfoPersonal setSnackbarVisibility={setSnackbarVisible} />
      </div>
      <Snackbar.Feedback
        visible={snackbarVisible}
        variant="alert"
        header="Information is missing"
        message="Please fill all required fields in order to proceed"
      />
    </Layout>
  )
}

export default Booking
